import { CourseMappingExportModel } from '../CourseMapping.interfaces';
import { ConversionErrorType } from './CSVConverterProvider.enums';
import { MetaDataError } from './CSVConverterProvider.interfaces';

const EXPECTED_FIELDS = ['mnsproCourse', 'timetableCourse', 'timetableCourseGroupType'];

export const toImportRows = (
  fields: string[] | undefined,
  data: CourseMappingExportModel[],
): { rows: CourseMappingExportModel[] } | { error: MetaDataError } => {
  const headerValid =
    !!fields && EXPECTED_FIELDS.every((field) => fields.includes(field));

  if (!headerValid) {
    return { error: { type: ConversionErrorType.DelimiterError } };
  }

  const rows = data.filter(
    (row) => !!row.timetableCourse && !!row.timetableCourseGroupType,
  );

  return { rows };
};
